<template lang="pug">
  .purpose.flex.items-center
    .rounded-full.w-8.h-8.mr-4.bg-yellow-5.flex.justify-center.items-center.flex-shrink-0
      eva-icon.icon.text-white(width="16" height="16" name="star")
    
    div(v-if="company")
      h3.text-sm.text-gray-6.font-medium Purpose
      .flex.items-end
        h2.text-xl.text-gray-6 {{company.purpose}}

</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: [],
  computed: {
    ...mapGetters(["company"])
  }
};
</script>

<style lang="sass" scoped></style>
